import React from 'react';
import { Switch as AntSwitch, SwitchProps } from 'antd';
import styled from 'styled-components';

const SelectWrapper = styled.div``;

interface OnChangeHandler {
  (e: any): void;
}

interface MySwitchProps extends SwitchProps {
  onChange?: OnChangeHandler;
  value?: boolean;
  checked?: boolean;
}

const Switch = ({
  value,
  checked,
  onChange,
  ...rest
}: MySwitchProps) => {
  const resolvedChecked =
    typeof checked === 'boolean'
      ? checked
      : typeof value === 'boolean'
        ? value
        : undefined;

  const switchProps: SwitchProps = {
    ...rest,
    onChange,
  };

  if (typeof resolvedChecked === 'boolean') {
    switchProps.checked = resolvedChecked;
  }

  return (
    <SelectWrapper>
      <AntSwitch {...switchProps} />
    </SelectWrapper>
  );
};

export default Switch;
